<template lang="pug">
	.app-core--loader.flex-col.space(:class="{ fullscreen }", :style="{ '--size': `${size}px` }")
		slot(name="top")
		.px-loader.loading.flex-row.space.align-center
			slot(name="left")
			.loader
				DxLoadIndicator(:height="size", :width="size")
			span(v-if="text") {{text}}
			slot(name="right")
		slot(name="bottom")
</template>

<script>

import VueTypes from 'vue-types';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';

export default {
	model: {
		prop: 'pageIndex',
		event: 'change'
	},
	props: {
		text: VueTypes.string.def('Loading..'),
		fullscreen: VueTypes.bool.def(false),
		icon: VueTypes.string.def('spinner'),
		size: VueTypes.number.def(24),
	},
	components: { DxLoadIndicator }
};

</script>

<style lang="scss">
	.app-core--loader {
		user-select: none;
		z-index: 500;

		&.fullscreen {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translateX(-50%) translateY(-50%);
			background: rgb(242,242,242);
			border-radius: 4px;
			padding: 8px;
			box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);
		}

		.loader {
			width: var(--size);
			height: var(--size);
			position: relative;

			.dx-loadindicator {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translateX(-50%) translateY(-50%)
			}
		}
	}
</style>
